<script setup lang="ts">
import LeLabel from "@dsk/components/Label/LeLabel.vue";
import LeBell from "@dsk/icons/LeBell.vue";

import { useFreeSearchLabel } from "@/composables";

defineProps<{
  freeSearchesLeft: number | null;
}>();

const { showFreeSearchCountdown, freeSearchLabelColor } = useFreeSearchLabel();
</script>

<template>
  <div v-if="showFreeSearchCountdown" class="le-free-searches-left-alert d-lg-none">
    <div class="le-free-searches-left-alert__inner">
      <LeBell width="20" height="20" class="le-free-searches-left-alert__icon" />
      <i18n-t tag="span" keypath="le-free-searches-left-alert.text">
        <template #count>
          <LeLabel :color="freeSearchLabelColor">{{ freeSearchesLeft }}</LeLabel>
        </template>
      </i18n-t>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-free-searches-left-alert {
  padding: 0 32px 0;

  &__inner {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 16px;
    border-radius: 4px;
    background-color: @colors[@neutrals][100];
    .body-text("s");
    color: @colors[@primary][900];
  }

  &__icon {
    margin-right: 12px;
  }
}
</style>
